import ajax from "@/utils/ajax.js";

export default {
    async getSchedulingsAsync(input) {
        let response = await ajax.post("/explainer/GetSchedulingsAsync", input);
        return response.result;
    },
    async beginExplainAsync(input) {
        return await ajax.post("/explainer/BeginExplainAsync", input);
    },
    async completeExplainAsync(input) {
        return await ajax.post("explainer/CompleteExplainAsync", input);
    },
    async getSchedulingsForBehalfAsync(input) {
        let response = await ajax.post("/explainer/GetSchedulingsForBehalfAsync", input);
        return response.result;
    },
    async getSchedulingsForTemporaryAsync(input) {
        let response = await ajax.post("/explainer/GetSchedulingsForTemporaryAsync", input);
        return response.result;
    }   
}